var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmeMondeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.345,
    height: 35.028,
    viewBox: "0 0 30.345 35.028",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ameMondeIcon",
    d: "M32.563,23.685A15.291,15.291,0,0,1,10.938,2.062,1.095,1.095,0,1,0,9.39.514a17.5,17.5,0,0,0,0,24.719A17.355,17.355,0,0,0,19.3,30.154v2.684H16.014a1.095,1.095,0,0,0,0,2.189h8.757a1.095,1.095,0,1,0,0-2.189H21.487v-2.5c.088,0,.175.013.263.013a17.426,17.426,0,0,0,12.36-5.112,1.1,1.1,0,0,0-1.548-1.55ZM21.75,0A12.873,12.873,0,1,0,34.623,12.873,12.872,12.872,0,0,0,21.75,0Zm0,23.556A10.683,10.683,0,1,1,32.434,12.873,10.7,10.7,0,0,1,21.75,23.556Z",
    transform: "translate(-4.278)",
    fill: "#A6D7EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmeMondeIcon);
export default __webpack_public_path__ + "static/media/ame-monde-icon.a5bf2b3ee76d36c31f97e3c24c9e92a8.svg";
export { ForwardRef as ReactComponent };